const UnpinLine = ({ className = '', ...props }) => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M1.90726 2.10397L1.86726 2.06396L1.16016 2.77107L3.49521 5.10612L2.35355 5.33433L1.64655 6.04183L3.76804 8.16283L1.29305 10.6378L2.00005 11.3448L4.47505 8.86983L6.59605 10.9913L7.30354 10.2843L7.5318 9.14272L9.46846 11.0794L10.1756 10.3723L10.1435 10.3402L10.1366 10.3472L1.90032 2.11092L1.90726 2.10397ZM8.68849 7.48488L9.77804 6.39533L10.1315 6.74883L10.839 6.04183L6.5963 1.79908L6.59655 1.79883H6.59605L6.5963 1.79908L5.88954 2.50633L6.24304 2.85983L5.15324 3.94963L5.86013 4.65651L6.95005 3.56683L9.07104 5.68833L7.98138 6.77776L8.68849 7.48488ZM3.20355 6.18433L4.3449 5.95581L6.68172 8.29264L6.45355 9.43433L3.20355 6.18433Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default UnpinLine;
